import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";
import Zoom from "yet-another-react-lightbox/plugins/zoom";
import Counter from "yet-another-react-lightbox/plugins/counter";
import Fullscreen from "yet-another-react-lightbox/plugins/fullscreen";
import "yet-another-react-lightbox/plugins/counter.css";

const floorPlansData = [
  {
    id: "228-east",
    size: "228 Sq.Yds",
    direction: "East",
    images: [
      { src: "/woods-floor-plan-images/228-east/285_east.jpg", label: "3D View" },
      { src: "/woods-floor-plan-images/228-east/228_east-ground.jpg", label: "Ground Floor" },
      { src: "/woods-floor-plan-images/228-east/228_east-first.jpg", label: "First Floor" },
      { src: "/woods-floor-plan-images/228-east/228_east-second.jpg", label: "Second Floor" }
    ]
  },
  {
    id: "238-east",
    size: "238 Sq.Yds",
    direction: "East",
    images: [
      { src: "/woods-floor-plan-images/238_east/238_east.jpg", label: "3D View" },
      { src: "/woods-floor-plan-images/238_east/238_east-ground.jpg", label: "Ground Floor" },
      { src: "/woods-floor-plan-images/238_east/238_east-first.jpg", label: "First Floor" },
      { src: "/woods-floor-plan-images/238_east/228_east-second.jpg", label: "Second Floor" }
    ]
  },
  {
    id: "244-east",
    size: "244 Sq.Yds",
    direction: "East",
    images: [
      { src: "/woods-floor-plan-images/244-east/285_east.jpg", label: "3D View" },
      { src: "/woods-floor-plan-images/244-east/244_east-ground.jpg", label: "Ground Floor" },
      { src: "/woods-floor-plan-images/244-east/244_east-first.jpg", label: "First Floor" },
      { src: "/woods-floor-plan-images/244-east/244_east-second.jpg", label: "Second Floor" }
    ]
  },
  {
    id: "265-east",
    size: "265 Sq.Yds",
    direction: "East",
    images: [
      { src: "/woods-floor-plan-images/265-east/285_west.jpg", label: "3D View" },
      { src: "/woods-floor-plan-images/265-east/265_east-ground.jpg", label: "Ground Floor" },
      { src: "/woods-floor-plan-images/265-east/265_east-first.jpg", label: "First Floor" },
      { src: "/woods-floor-plan-images/265-east/265_east-second.jpg", label: "Second Floor" }
    ]
  },
  {
    id: "266-east",
    size: "266 Sq.Yds",
    direction: "East",
    images: [
      { src: "/woods-floor-plan-images/266-east/266_east.jpg", label: "3D View" },
      { src: "/woods-floor-plan-images/266-east/266_east-ground.jpg", label: "Ground Floor" },
      { src: "/woods-floor-plan-images/266-east/266_east-first.jpg", label: "First Floor" },
      { src: "/woods-floor-plan-images/266-east/266_east-second.jpg", label: "Second Floor" }
    ]
  },
  {
    id: "285-east",
    size: "285 Sq.Yds",
    direction: "East",
    images: [
      { src: "/woods-floor-plan-images/285-east/285-east.jpg", label: "3D View" },
      { src: "/woods-floor-plan-images/285_east/285_east.jpg", label: "3D View 2" },
      { src: "/woods-floor-plan-images/285-east/285-east-ground.jpg", label: "Ground Floor" },
      { src: "/woods-floor-plan-images/285-east/285-east-first.jpg", label: "First Floor" },
      { src: "/woods-floor-plan-images/285-east/285-east-second.jpg", label: "Second Floor" }
    ]
  },
  {
    id: "316-east",
    size: "316 Sq.Yds",
    direction: "East",
    images: [
      { src: "/woods-floor-plan-images/316-east/316-east.jpg", label: "3D View" },
      { src: "/woods-floor-plan-images/316-east/316_east_ground.jpg", label: "Ground Floor" },
      { src: "/woods-floor-plan-images/316-east/316_east_first.jpg", label: "First Floor" },
      { src: "/woods-floor-plan-images/316-east/316_east_second.jpg", label: "Second Floor" }
    ]
  },
  {
    id: "319-east",
    size: "319 Sq.Yds",
    direction: "East",
    images: [
      { src: "/woods-floor-plan-images/319_east/319_east.jpg", label: "3D View" },
      { src: "/woods-floor-plan-images/319_east/319_east_ground.jpg", label: "Ground Floor" },
      { src: "/woods-floor-plan-images/319_east/319_east_first.jpg", label: "First Floor" },
      { src: "/woods-floor-plan-images/319_east/319_east_second.jpg", label: "Second Floor" }
    ]
  },
  {
    id: "320-east",
    size: "320 Sq.Yds",
    direction: "East",
    images: [
      { src: "/woods-floor-plan-images/320-east/320-east.jpg", label: "3D View" },
      { src: "/woods-floor-plan-images/320-east/320_east-ground.jpg", label: "Ground Floor" },
      { src: "/woods-floor-plan-images/320-east/320_east-first.jpg", label: "First Floor" },
      { src: "/woods-floor-plan-images/320-east/320_east-second.jpg", label: "Second Floor" }
    ]
  },
  {
    id: "330-east",
    size: "330 Sq.Yds",
    direction: "East",
    images: [
      { src: "/woods-floor-plan-images/330-east/330-east.jpg", label: "3D View" },
      { src: "/woods-floor-plan-images/330-east/330_east_ground.jpg", label: "Ground Floor" },
      { src: "/woods-floor-plan-images/330-east/330_east_second.jpg", label: "Second Floor" }
    ]
  },
  {
    id: "340-east",
    size: "340 Sq.Yds",
    direction: "East",
    images: [
      { src: "/woods-floor-plan-images/340-east/340-east.jpg", label: "3D View" },
      { src: "/woods-floor-plan-images/340-east/340_east_ground.jpg", label: "Ground Floor" },
      { src: "/woods-floor-plan-images/340-east/340_east_first.jpg", label: "First Floor" },
      { src: "/woods-floor-plan-images/340-east/340_east_second.jpg", label: "Second Floor" }
    ]
  },
  {
    id: "238-west",
    size: "238 Sq.Yds",
    direction: "West",
    images: [
      { src: "/woods-floor-plan-images/238-west/238-west.jpg", label: "3D View" },
      { src: "/woods-floor-plan-images/238-west/238_west_ground.jpg", label: "Ground Floor" },
      { src: "/woods-floor-plan-images/238-west/238_west_first.jpg", label: "First Floor" },
      { src: "/woods-floor-plan-images/238-west/238_west_second.jpg", label: "Second Floor" }
    ]
  },
  {
    id: "240-west",
    size: "240 Sq.Yds",
    direction: "West",
    images: [
      { src: "/woods-floor-plan-images/240-west/240-west.jpg", label: "3D View" },
      { src: "/woods-floor-plan-images/240-west/240_west_ground.jpg", label: "Ground Floor" },
      { src: "/woods-floor-plan-images/240-west/240_west_first.jpg", label: "First Floor" },
      { src: "/woods-floor-plan-images/240-west/240_west_second.jpg", label: "Second Floor" }
    ]
  },
  {
    id: "256-west",
    size: "256 Sq.Yds",
    direction: "West",
    images: [
      { src: "/woods-floor-plan-images/256-west/256-west.jpg", label: "3D View" },
      { src: "/woods-floor-plan-images/256-west/256_west_ground.jpg", label: "Ground Floor" },
      { src: "/woods-floor-plan-images/256-west/256_west_first.jpg", label: "First Floor" },
      { src: "/woods-floor-plan-images/256-west/256_west_second.jpg", label: "Second Floor" }
    ]
  },
  {
    id: "260-west",
    size: "260 Sq.Yds",
    direction: "West",
    images: [
      { src: "/woods-floor-plan-images/260_west/260_west.jpg", label: "3D View" },
      { src: "/woods-floor-plan-images/260_west/260_west_ground.jpg", label: "Ground Floor" },
      { src: "/woods-floor-plan-images/260_west/260_west_first.jpg", label: "First Floor" },
      { src: "/woods-floor-plan-images/260_west/260_west_second.jpg", label: "Second Floor" }
    ]
  },
  {
    id: "285-west",
    size: "285 Sq.Yds",
    direction: "West",
    images: [
      { src: "/woods-floor-plan-images/285_west/285_west.jpg", label: "3D View" },
      { src: "/woods-floor-plan-images/285_west/285-WEST-ground.jpg", label: "Ground Floor" },
      { src: "/woods-floor-plan-images/285_west/285-WEST-first.jpg", label: "First Floor" },
      { src: "/woods-floor-plan-images/285_west/285-WEST-second.jpg", label: "Second Floor" }
    ]
  },
  {
    id: "316-west",
    size: "316 Sq.Yds",
    direction: "West",
    images: [
      { src: "/woods-floor-plan-images/316-west/316-west.jpg", label: "3D View" },
      { src: "/woods-floor-plan-images/316-west/316_west_ground.jpg", label: "Ground Floor" },
      { src: "/woods-floor-plan-images/316-west/316_west_first.jpg", label: "First Floor" },
      { src: "/woods-floor-plan-images/316-west/316_west_second.jpg", label: "Second Floor" }
    ]
  },
  {
    id: "320-west",
    size: "320 Sq.Yds",
    direction: "West",
    images: [
      { src: "/woods-floor-plan-images/320-west/320-west.jpg", label: "3D View" },
      { src: "/woods-floor-plan-images/320-west/320-west-ground.jpg", label: "Ground Floor" },
      { src: "/woods-floor-plan-images/320-west/320-west-first.jpg", label: "First Floor" },
      { src: "/woods-floor-plan-images/320-west/320-west-second.jpg", label: "Second Floor" }
    ]
  },
  {
    id: "325-west",
    size: "325 Sq.Yds",
    direction: "West",
    images: [
      { src: "/woods-floor-plan-images/325_west/325_west.jpg", label: "3D View" },
      { src: "/woods-floor-plan-images/325_west/325_west_ground.jpg", label: "Ground Floor" },
      { src: "/woods-floor-plan-images/325_west/325_west_first.jpg", label: "First Floor" },
      { src: "/woods-floor-plan-images/325_west/325_west_second.jpg", label: "Second Floor" }
    ]
  }
];

const planGroups = ["East", "West"].map((direction) => ({
  direction,
  plans: floorPlansData.filter((plan) => plan.direction === direction),
}));

export default function FloorPlansWoods() {
  const [activeTab, setActiveTab] = useState(floorPlansData[0].id);
  const [open, setOpen] = useState(false);
  const [slides, setSlides] = useState([]);
  const [index, setIndex] = useState(0);

  const activeData = floorPlansData.find((d) => d.id === activeTab) || floorPlansData[0];

  const openGallery = (idx) => {
    setSlides(activeData.images.map((img) => ({ src: img.src })));
    setIndex(idx);
    setOpen(true);
  };

  return (
    <section className="woods-floorplans-section" id="woods-floor-plans">
      <div className="container">
        <motion.div
          className="woods-floorplans-header"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.35 }}
          transition={{ duration: 0.75 }}
        >
          <p className="woods-floorplans-kicker">Villa Plans</p>
          <div className="woods-floorplans-title-row">
            <h2 className="woods-floorplans-title">Floor Plans</h2>
            <div className="woods-floorplans-current" aria-live="polite">
              <span>{activeData.size}</span>
              <small>{activeData.direction} Facing</small>
            </div>
          </div>
        </motion.div>

        <div className="woods-floorplans-layout">
          <aside className="woods-floorplans-tabs" aria-label="Floor plan options">
            {planGroups.map((group) => (
              <div className="woods-floorplans-tab-column" key={group.direction}>
                <h3 className="woods-floorplans-tab-title">{group.direction}</h3>
                {group.plans.map((tab) => (
                  <button
                    key={tab.id}
                    type="button"
                    className={`woods-floorplans-tab ${activeTab === tab.id ? "is-active" : ""}`}
                    onClick={() => setActiveTab(tab.id)}
                    aria-pressed={activeTab === tab.id}
                  >
                    <span>{tab.size}</span>
                  </button>
                ))}
              </div>
            ))}
          </aside>

          <div className="woods-floorplans-gallery">
            <AnimatePresence mode="wait">
              <motion.div
                key={activeTab}
                className="woods-floorplans-grid"
                initial={{ opacity: 0, y: 18 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -18 }}
                transition={{ duration: 0.35 }}
              >
                {activeData.images.map((img, idx) => (
                  <motion.button
                    type="button"
                    className="woods-floorplan-card"
                    key={img.label}
                    onClick={() => openGallery(idx)}
                    whileHover={{ y: -6 }}
                    transition={{ duration: 0.25 }}
                  >
                    <span className="woods-floorplan-media">
                      <img
                        src={img.src}
                        alt={`${activeData.size} ${activeData.direction} ${img.label}`}
                        loading="lazy"
                      />
                    </span>
                    <span className="woods-floorplan-card-copy">
                      <span className="woods-floorplan-label">{img.label}</span>
                      <span className="woods-floorplan-action" aria-hidden="true">View</span>
                    </span>
                  </motion.button>
                ))}
              </motion.div>
            </AnimatePresence>
          </div>
        </div>
      </div>

      <Lightbox
        open={open}
        close={() => setOpen(false)}
        slides={slides}
        index={index}
        plugins={[Zoom, Counter, Fullscreen]}
        imageFit="contain"
        zoom={{
          maxZoomPixelRatio: 4,
          zoomInMultiplier: 1.5,
          doubleTapDelay: 300,
          doubleClickDelay: 300,
        }}
        on={{ view: ({ index: currentIndex }) => setIndex(currentIndex) }}
        counter={{
          container: {
            style: { top: "16px", left: "16px", right: "auto", bottom: "auto", fontSize: "14px" },
          },
        }}
        styles={{ container: { backgroundColor: "rgba(0,0,0,0.96)" } }}
      />
    </section>
  );
}
